import React from 'react';

import MinusImgSrc from 'assets/icons/minus.svg';
import PlusImgSrc from 'assets/icons/plus.svg';

type Props = {
  inc: () => void;
  dec: () => void;
};

export default function FloatingSlider(props: Props) {
  const {inc, dec} = props;
  return (
    <div className="absolute left-0 bottom-0 p-4">
      <div className="flex flex-col-reverse bg-skyblue rounded-lg items-center">
        <div className="p-2 cursor-pointer" onClick={dec}>
          <img src={MinusImgSrc} alt="-" />
        </div>
        <div className="p-2 cursor-pointer" onClick={inc}>
          <img src={PlusImgSrc} alt="+" />
        </div>
      </div>
    </div>
  );
}
